module.exports = __webpack_public_path__ + "static/media/Pro-Clo-Serv.5ea00f3d.png";